import { createContext } from 'react';
const usingWithoutProvider = () => {
    console.error('You are using the S3DataAuthContext without a provider');
};
const S3DataAuthContext = createContext({
    status: 'idle',
    authorizeS3DataCalls: usingWithoutProvider,
});
export default S3DataAuthContext;
